import { View, Text } from 'react-native'
import { useRouter } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { Button } from '@/src/common/components/Button'
import { useSardine } from '@/src/services/Sardine'
import { useEffect } from 'react'
import { CardApplicationWrapper } from './cardApplicationWrapper'
import { typography } from '@/src/common/theme'
import { cardApplicationStyles as commonStyle } from './common'
import * as E2E from '../../e2e'

export function ApplicationInReview() {
  const router = useRouter()
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'application-in-review' })
  }, [updateOptions])

  return (
    <CardApplicationWrapper testID={E2E.Config.Ids.View.InReview}>
      <View style={commonStyle.headerText}>
        <Text style={typography['heading/heading2']}>You're almost done</Text>
      </View>
      <Text style={commonStyle.instructionText}>
        We are reviewing a few additional pieces of information. We will reach out to you in app or
        via email within 1-2 business days.
      </Text>
      <View style={{ flex: 1 }} />
      <View style={{ marginBottom: 0, gap: 10 }}>
        <Button
          title="Return Home"
          onPress={() => router.replace(Routes.Main.route)}
          testID={E2E.Config.Ids.Press.InReviewReturnHome}
        />
      </View>
    </CardApplicationWrapper>
  )
}
